'use strict';

var env = require('@flex-packages/env');
var constants = require('./constants.cjs');
var DefaultEvent = require('./exception-event-data/DefaultEvent.cjs');
var AxiosEvent = require('./exception-event-data/AxiosEvent.cjs');

function beforeSend(event, hint) {
  const eventData = eventDataFactory(event, hint);
  return addRouteTo(editEvent(event, eventData));
}
function eventDataFactory(event, hint) {
  if (AxiosEvent.isAxiosErrorHint(hint)) {
    return new AxiosEvent(event, hint);
  }
  return new DefaultEvent(event);
}
function editEvent(event, data) {
  const originExceptionList = event.exception?.values;
  const titleException = originExceptionList?.[originExceptionList.length - 1];
  if (titleException) {
    titleException.type = data.getType();
    titleException.value = data.getValue();
  }
  return {
    ...event,
    level: data.getLevel(),
    fingerprint: data.getFingerPrint(),
    exception: event.exception,
    extra: { ...data.getExtra(), ...event.extra }
  };
}
function addRouteTo(event) {
  const originExceptionList = event.exception?.values;
  if (!originExceptionList) {
    return event;
  }
  const initialException = originExceptionList[0];
  if (!initialException?.stacktrace?.frames) {
    return event;
  }
  const routeTo = initialException.stacktrace.frames.filter((frame) => frame.module_metadata && frame.module_metadata.appId).map((frame) => {
    return {
      dsn: env.getRuntimeEnvWithSafeAccessToWindow(
        `${frame.module_metadata.appId}Env`
      )?.SENTRY_DSN,
      release: event.release || ""
    };
  }).pop();
  if (!routeTo?.dsn) {
    return event;
  }
  return {
    ...event,
    extra: {
      ...event.extra,
      [constants.EVENT_EXTRA_KEY_FOR_ROUTE_TO]: [routeTo]
    }
  };
}

exports.beforeSend = beforeSend;
//# sourceMappingURL=beforeSend.cjs.map
